const YOUTUBE_THUMBNAIL_URL =
  /^https:\/\/img\.youtube\.com\/vi\/[A-Za-z0-9_-]+\//;

/** Kept unmirrored: the app reads the video id out of this URL to embed the player. */
export function youtubeThumbnailUrl(videoId: string): string {
  return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
}

export function isYouTubeThumbnailUrl(url: string): boolean {
  return YOUTUBE_THUMBNAIL_URL.test(url);
}
